import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { PageInfo } from './page-info';
import { NavSectionEnum } from './nav-section.enum';

/**
 * Used to communicate information about the skin components such as the header and navbar.
 */
@Injectable()
export class PageInfoService {

// #region [ Fields ]

	/** The event emitter for communicating page title changes. */
	private _InfoChangedEmitter: EventEmitter<PageInfo> = new EventEmitter<PageInfo>();

	/** The data object used for communiation. */
	private _PageInfo: PageInfo = new PageInfo();

// #region [ Properties ]

	/** The page title. */
	public get PageTitle(): string {
		return this._PageInfo.PageTitle;
	}

	/**
	 * The page title.
	 *
	 * @event PageInfoService#PageInfoChange
	 */
	public set PageTitle(PageTitle: string) {
		this._PageInfo.PageTitle = PageTitle;
		this._InfoChangedEmitter.emit(this._PageInfo);
	}

	/** The page description. */
	public get PageDescription(): string {
		return this._PageInfo.PageDescription;
	}

	/**
	 * The page description.
	 *
	 * @event PageInfoService#PageInfoChange
	 */
	public set PageDescription(PageDescription: string) {
		this._PageInfo.PageDescription = PageDescription;
		this._InfoChangedEmitter.emit(this._PageInfo);
	}

	/** The current navigation section. */
	public get CurrentSection(): NavSectionEnum {
		return this._PageInfo.CurrentSection;
	}

	/**
	 * The current navigation section.
	 *
	 * @event PageInfoService#PageInfoChange
	 */
	public set CurrentSection(Section: NavSectionEnum) {
		this._PageInfo.CurrentSection = Section;
		this._InfoChangedEmitter.emit(this._PageInfo);
	}
	
	/*
	 * Indicates if the user panel should be shown in the header layout component.
	 */
	public get ShowHeaderUserPanel(): boolean {
		return this._PageInfo.ShowHeaderUserPanel;
	}

	/*
	 * Sets a value which indicates if the user panel should be shown in the header layout component.
	 */
	public set ShowHeaderUserPanel(Value: boolean) {
		this._PageInfo.ShowHeaderUserPanel = Value;
		this._InfoChangedEmitter.emit(this._PageInfo);
	}

	/*
	 * Indicates if the help panel should be shown in the header layout component.
	 */
	public get ShowHeaderHelpPanel(): boolean {
		return this._PageInfo.ShowHeaderHelpPanel;
	}

	/*
	 * Sets a value which indicates if the help panel should be shown in the header layout component.
	 */
	public set ShowHeaderHelpPanel(Value: boolean) {
		this._PageInfo.ShowHeaderHelpPanel = Value;
		this._InfoChangedEmitter.emit(this._PageInfo);
	}

// #region [ Public Methods ]

	/**
	 * Gets an observable used to subscribe to data changes.
	 *
	 * @returns     An observable that can be subscribed to to moitor page info changes.
	 */
	public GetPageInfoObserver(): Observable<PageInfo> {
		return this._InfoChangedEmitter.asObservable();
	}

}